export enum WorkflowStatus {
    // Initial state — bootstrap API has not yet returned. No navigation should fire.
    IDLE = 'IDLE',
    BOOTSTRAP_ERROR = 'BOOTSTRAP_ERROR',
    ROLE_ASSUMPTION_REQUIRED = 'ROLE_ASSUMPTION_REQUIRED',
    INVALID = 'INVALID',
    MISSING_VEHICLE = 'MISSING_VEHICLE',
    IN_PROGRESS = 'IN_PROGRESS',
    REDIRECT_TO_SALES_VIEW = 'REDIRECT_TO_SALES_VIEW',
    SENT_FOR_DESKING = 'SENT_FOR_DESKING',
    DESKED = 'DESKED',
    ACCEPTED = 'ACCEPTED'
}

export type DealSummaryWorkflowStatus = WorkflowStatus.ACCEPTED | WorkflowStatus.DESKED | WorkflowStatus.SENT_FOR_DESKING;
